import { PostDetailsType } from '@anytag/shared-types';
import { PaginationProps, TableV2 } from '@anytag/shared-atoms';
import { CampaignPostDetailsModal } from '@anytag/shared-molecules';
import { MarketplaceCampaignReport, NewCampaignReportSummary } from '@anytag/graphql';
import { usePostReportContext } from '../PostReportContext';
import { PostReportSegment } from './types';
import { usePostReportTable } from './hooks';
import { formatPostReportData } from './utils';

export interface PostReportTableProps {
  loading?: boolean;
  segment: PostReportSegment;
  data: MarketplaceCampaignReport;
  pagination?: PaginationProps;
  summaryData?: NewCampaignReportSummary;
}

export const PostReportTable = ({ data, segment, pagination, loading, summaryData }: PostReportTableProps) => {
  const { campaignType, tableRef } = usePostReportContext();
  const { columns } = usePostReportTable({ data });

  const tableData = formatPostReportData({ data, segment, summaryData });
  const allPosts = tableData.reduce<PostDetailsType[]>((acc, { influencerInfo, postInfo }) => {
    if (influencerInfo && influencerInfo.postLength === 1 && influencerInfo.firstPost) {
      acc.push({ id: String(influencerInfo.firstPost.id), influencerId: influencerInfo.id, campaignType });
    } else if (postInfo) {
      acc.push({ id: String(postInfo.id), influencerId: postInfo.influencerId, campaignType });
    }

    return acc;
  }, []);

  return (
    <>
      <TableV2
        data={tableData}
        loading={loading}
        pagination={pagination}
        noTopBorderRadius
        rowHeight="64px"
        columns={columns}
        hasColumnCustomization
        stickyHeader
        hasBorder
        maxHeight="820px"
        className="report-table"
        reactTableRef={tableRef}
      />

      <CampaignPostDetailsModal posts={allPosts} engPostProps={{ hasTrafficSource: true }} />
    </>
  );
};
